// Generated by CoffeeScript 2.7.0
var DatePickerMixin;

export default DatePickerMixin = {
  props: {
    initValue: {
      type: Date
    },
    limitStart: {
      type: Date,
      default: null
    },
    limitEnd: {
      type: Date,
      default: null
    }
  },
  data: function() {
    return {
      // 1(year) | 2(month) | 3(day)
      viewMode: 3,
      value: this.initValue || new Date()
    };
  },
  computed: {
    currentValue: function() {
      var ref;
      return ((ref = this.value) != null ? ref.strftime('YYYY-MM-DD') : void 0) || '';
    },
    monthValue: function() {
      var ref;
      return ((ref = this.value) != null ? ref.strftime('YYYY-MM') : void 0) || '';
    },
    year: function() {
      var ref;
      return ((ref = this.value) != null ? ref.getFullYear() : void 0) || '';
    },
    month: function() {
      var ref;
      return ((ref = this.value) != null ? ref.getMonth() : void 0) || '';
    },
    day: function() {
      var ref;
      return ((ref = this.value) != null ? ref.getDate() : void 0) || '';
    },
    displayValue: function() {
      switch (this.viewMode) {
        case 1:
          return `${this.value.getFullYear() - 6} - ${this.value.getFullYear() + 5}`;
        case 2:
          return this.value.strftime('YYYY 年');
        case 3:
          return this.value.strftime('YYYY 年 MM 月');
      }
    },
    displayRange: function() {
      switch (this.viewMode) {
        case 1:
          return this._getYears();
        case 2:
          return this._getMonths();
        case 3:
          return this._getDayWeeks();
      }
    }
  },
  watch: {
    value: function() {
      return this.$emit('valueChanged', this.value);
    }
  },
  methods: {
    setDate: function(date = new Date()) {
      return this.value = date;
    },
    increaseView: function(increment) {
      return this.value = (function() {
        switch (this.viewMode) {
          case 1:
            return this.value.lastDays(-1 * increment * 12, 0, 0);
          case 2:
            return this.value.lastDays(-1 * increment, 0, 0);
          case 3:
            return this.value.lastDays(0, -1 * increment, 0);
        }
      }).call(this);
    },
    updateDay: function(day) {
      if (day.status === 'disabled') {
        return;
      }
      return this.value = Date.parseFromString(day.key);
    },
    updateMonth: function(month) {
      if (month.status === 'disabled') {
        return;
      }
      this.value = this.value.lastDays(0, this.value.getMonth() - month.text, 0);
      return this.viewMode += 1;
    },
    updateYear: function(year) {
      if (year.status === 'disabled') {
        return;
      }
      this.value = this.value.lastDays(this.value.getFullYear() - year.key, 0, 0);
      return this.viewMode += 1;
    },
    reflowView: function() {
      if (this.viewMode === 1) {
        return;
      }
      return this.viewMode -= 1;
    },
    _getYears: function() {
      var current_year, last_end_year, ref, years;
      current_year = this.value.getFullYear();
      last_end_year = Math.floor(current_year / 12) * 12;
      years = _.map((function() {
        var results = [];
        for (var i = last_end_year, ref = last_end_year + 12; last_end_year <= ref ? i < ref : i > ref; last_end_year <= ref ? i++ : i--){ results.push(i); }
        return results;
      }).apply(this), (year) => {
        var key_date, key_end_date, status;
        key_date = new Date(year, 0, 1, 0, 0, 0);
        key_end_date = new Date(year, 12, 0, 23, 59, 59);
        status = (this.limitStart && this.limitStart > key_end_date) || (this.limitEnd && this.limitEnd < key_date) ? 'disabled' : '';
        return {
          text: year,
          key: year,
          status: status
        };
      });
      return years.groupByLength(4);
    },
    _getMonths: function() {
      var current_year, months;
      current_year = this.value.getFullYear();
      months = _.map([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], (month) => {
        var key_date, key_end_date, status;
        // 当月第一刻
        key_date = new Date(current_year, month, 1, 0, 0, 0);
        // 当月最后一刻
        key_end_date = new Date(current_year, month + 1, 0, 23, 59, 59);
        status = (this.limitStart && this.limitStart > key_end_date) || (this.limitEnd && this.limitEnd < key_date) ? 'disabled' : '';
        return {
          text: month,
          key: key_date.strftime('YYYY-MM'),
          status: status
        };
      });
      return months.groupByLength(4);
    },
    _getDayWeeks: function() {
      var currentMonthDays, current_month, current_year, first_day, lastMonthDays, last_month_days, nextMonthDays, ref, ref1, ref2;
      current_year = this.value.getFullYear();
      current_month = this.value.getMonth();
      first_day = new Date(current_year, current_month, 1);
      last_month_days = new Date(current_year, current_month - 1, 1).maxDateNumber;
      lastMonthDays = _.map((function() {
        var results = [];
        for (var i = 0, ref = first_day.getDay(); 0 <= ref ? i < ref : i > ref; 0 <= ref ? i++ : i--){ results.push(i); }
        return results;
      }).apply(this), (item, index, arr) => {
        var _date, _day;
        _day = last_month_days + item - arr.length;
        _date = new Date(current_year, current_month - 1, _day);
        return {
          text: _day,
          key: _date.strftime('YYYY-MM-DD'),
          status: this.__getRangeStatus(_date) || 'readonly'
        };
      });
      currentMonthDays = (function() {
        var results = [];
        for (var i = 1, ref1 = this.value.maxDateNumber; 1 <= ref1 ? i <= ref1 : i >= ref1; 1 <= ref1 ? i++ : i--){ results.push(i); }
        return results;
      }).apply(this).map((day) => {
        var _date;
        _date = new Date(current_year, current_month, day);
        return {
          text: day,
          key: _date.strftime('YYYY-MM-DD'),
          status: this.__getRangeStatus(_date)
        };
      });
      nextMonthDays = (function() {
        var results = [];
        for (var i = 1, ref2 = 42 - (lastMonthDays.length + currentMonthDays.length); 1 <= ref2 ? i <= ref2 : i >= ref2; 1 <= ref2 ? i++ : i--){ results.push(i); }
        return results;
      }).apply(this).map((day) => {
        var _date;
        _date = new Date(current_year, current_month + 1, day);
        return {
          text: day,
          key: _date.strftime('YYYY-MM-DD'),
          status: this.__getRangeStatus(_date) || 'readonly'
        };
      });
      return lastMonthDays.concat(currentMonthDays).concat(nextMonthDays).groupByLength(7);
    },
    __getRangeStatus: function(day, start = this.limitStart, end = this.limitEnd) {
      if ((start && start.midnight() > day) || (end && end.endOfDay() < day)) {
        return 'disabled';
      } else {
        return '';
      }
    }
  }
};
